// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-08d960a6] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.transfer[data-v-08d960a6] {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n.transfer-item[data-v-08d960a6] {\n  flex: 1;\n  height: 100%;\n}\n.button-group[data-v-08d960a6] {\n  display: flex;\n  flex-direction: column;\n  margin: 0 20px;\n}\n.arrow-btn[data-v-08d960a6] {\n  margin: 20px 0;\n  margin-left: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
